import { getI18n, useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

export default function DropDownList({
  placeholder,
  label,
  data,
  exceptTranslation = false,
  additionalInfo = false,
  ...props
}: any) {
  const currentLanguage = getI18n()?.language || "en";
  const { t } = useTranslation();

  // Ensure data is an array
  const safeData = Array.isArray(data) ? data : [];

  // Process the data to handle display labels
  const processedData = safeData
    .map((item) => {
      try {
        if (item?.display_label) {
          return {
            ...item,
            label:
              item.display_label[currentLanguage] ||
              item.display_label["en"] ||
              "",
          };
        }
        return item;
      } catch (error) {
        console.error("Error processing item:", item, error);
        return item;
      }
    })
    .filter(Boolean); // Remove any null/undefined items

  const renderSelectItem = (item, index: number) => {
    if (!item?.value) return null;

    if (additionalInfo) {
      return (
        <SelectItem key={item.value || index} value={item.value}>
          <div className="flex items-center gap-2">
            {item.image && (
              <div className="flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.name || ""}
                  width={20}
                  height={20}
                  className="object-contain"
                />
              </div>
            )}
            <div className="truncate">
              {exceptTranslation
                ? typeof item.label === "string"
                  ? item.label
                  : item.label?.[currentLanguage]
                : t(typeof item.label === "string" ? item.label : "")}
            </div>
          </div>
        </SelectItem>
      );
    }

    return (
      <SelectItem className="pl-6" key={item.value || index} value={item.value}>
        {exceptTranslation
          ? typeof item.label === "string"
            ? item.label
            : item.label?.[currentLanguage]
          : t(typeof item.label === "string" ? item.label : "")}
      </SelectItem>
    );
  };

  return (
    <Select {...props}>
      <SelectTrigger className="w-full">
        <SelectValue className="truncate" placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-[300px] overflow-y-auto">
        <SelectGroup>
          {label && <SelectLabel>{label}</SelectLabel>}
          {processedData.map((item, index) => (
            <div key={item?.value || index}>
              {renderSelectItem(item, index)}
            </div>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
